import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import client, { signUpload } from "@culturehq/client";
import { Form, Info, Panel, SubmitButton, Warning } from "@culturehq/components";

import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import Event from "components/events/Event";
import MultiImageField from "./MultiImageField";

class CreatePhotos extends Component {
  state = { error: null, success: false };

  handleSubmit = async ({ images }) => {
    const { event: { id: eventId } } = this.props;
    const imageUrls = await Promise.all(images.map(image => signUpload(image)));

    try {
      this.setState({ error: null });
      await client.bulkCreateEventPhotos({ eventId, imageUrls });

      this.setState({ success: true });
    } catch (error) {
      const errorList = Object.keys(error).map(filename => (
        t(`${filename} is not a valid image.`)
      ));

      this.setState({ error: errorList.join(" ") });
    }
  };

  render() {
    const { event: eventData } = this.props;
    const { success, error } = this.state;
    const event = new Event(eventData);

    if (success) {
      return <Redirect to={`/events/${event.id}/photos`} />;
    }

    return (
      <div className="Event__Photos">
        {event.cancelledAt && (
          <Warning>
            <Trans>This event has been cancelled.</Trans>
          </Warning>
        )}

        {event.isPast() && !event.cancelledAt && (
          <Info>
            <Trans>This event has ended.</Trans>
          </Info>
        )}
        <Panel>
          <Panel.Body>
            {error && <ErrorMessage error={error} />}
            <Form className="chq-umf" onSubmit={this.handleSubmit}>
              <MultiImageField name="images">
                Images
              </MultiImageField>
              <SubmitButton primary>
                {submitting => (submitting ? t("Uploading...") : t("Save Photos"))}
              </SubmitButton>
            </Form>
            <p className="text-center">
              <Link to={`/events/${event.id}/photos`}>
                <Trans>Back to Photos</Trans>
              </Link>
            </p>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

export default CreatePhotos;
